import { createSlice } from "@reduxjs/toolkit";
import { IAgentPoliciesSlice } from "../../models/agent/policiesListing";
import { GetAgentPolicies } from "./PolicyListingAction";

const initialState: IAgentPoliciesSlice = {
  policyList: [],
  policyCount: 0,
  currentContinuationId: null,
  prevContinuationId: null,
  nextContinuationId: null,
};

const AgentPoliciesListingSlice = createSlice({
  name: "agentPoliciesListing",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAgentPolicies.fulfilled, (state, { payload }) => {
      // if (payload.status === "SUCCESS") {
      state.policyList = payload.data ? payload.data.policyList : [];
      state.policyCount = payload.data ? payload.data.policyCount : 0;
      state.currentContinuationId = payload.data
        ? payload.data.currentContinuationId
        : null;
      state.prevContinuationId = payload.data
        ? payload.data.prevContinuationId
        : null;
      state.nextContinuationId = payload.data
        ? payload.data.nextContinuationId
        : null;
      // }
    });
  },
});

export default AgentPoliciesListingSlice.reducer;
